export const CASINO_GAMES_SLIDER_LIMIT_MULTIPLIER = 2;
